import { render, staticRenderFns } from "./BTN001n_straight.vue?vue&type=template&id=1a78fe20&scoped=true&"
import script from "./BTN001n_straight.vue?vue&type=script&lang=js&"
export * from "./BTN001n_straight.vue?vue&type=script&lang=js&"
import style0 from "./BTN001n_straight.vue?vue&type=style&index=0&id=1a78fe20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a78fe20",
  null
  
)

export default component.exports